module.exports = __webpack_public_path__ + "static/media/композиции.036814c9.jpg";